<dx-select-box [dataSource]="dataSource"
               [value]="roleId"
               [grouped]="true"
               (onValueChanged)="onRoleIdChanged($event)"
               [searchEnabled]="true"
               [showClearButton]="true"
               valueExpr="roleId"
               displayExpr="label"></dx-select-box>
